var _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWebinarsSvg = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_i_12117_27531)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.83594 4.52067C5.83608 4.44296 5.85692 4.36669 5.89631 4.29971C5.9357 4.23273 5.99222 4.17745 6.06006 4.13955C6.1279 4.10165 6.20461 4.0825 6.2823 4.08407C6.35999 4.08565 6.43586 4.10789 6.5021 4.1485L8.63944 5.46042C8.70314 5.49956 8.75574 5.55437 8.79224 5.61963C8.82873 5.68488 8.84789 5.7584 8.84789 5.83317C8.84789 5.90793 8.82873 5.98145 8.79224 6.0467C8.75574 6.11196 8.70314 6.16677 8.63944 6.20592L6.5021 7.51842C6.43577 7.55908 6.3598 7.58132 6.282 7.58285C6.20421 7.58437 6.12742 7.56512 6.05955 7.52708C5.99168 7.48905 5.93518 7.4336 5.89587 7.36645C5.85656 7.2993 5.83588 7.22289 5.83594 7.14508V4.52067Z",
  stroke: "#F35B22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_i_12117_27531)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.08594 12.25H9.91927",
  stroke: "#F35B22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_i_12117_27531)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.6641 1.75H2.33073C1.6864 1.75 1.16406 2.27233 1.16406 2.91667V8.75C1.16406 9.39433 1.6864 9.91667 2.33073 9.91667H11.6641C12.3084 9.91667 12.8307 9.39433 12.8307 8.75V2.91667C12.8307 2.27233 12.3084 1.75 11.6641 1.75Z",
  stroke: "#F35B22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_i_12117_27531",
  x: 5.33594,
  y: 3.58398,
  width: 5.01562,
  height: 5.49902,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_12117_27531"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_i_12117_27531",
  x: 3.58594,
  y: 11.75,
  width: 7.83594,
  height: 2,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_12117_27531"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_i_12117_27531",
  x: 0.664062,
  y: 1.25,
  width: 13.6641,
  height: 10.167,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_12117_27531"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWebinarsSvg);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";